
export const choseoption_data = [
    { label: 'Small' },
    { label: 'Extra Small' },
    { label: 'Medium' },
    { label: 'Large' },
    { label: 'Extra Large' },
    { label: 'Double Extra Large' },
    { label: 'XS' },
    { label: 'S' },
    { label: 'M' },
    { label: 'L' },
    { label: 'XL' },
    { label: 'XXL' },
  ]
  export const choosecolor_data = [
    { label: 'Black',  },
    { label: 'Gray',  },
    { label: 'Red',  },
    { label: 'Green', },
    { label: 'Pink',  },
    { label: 'Brown', },
    { label: 'Yellow', },
    { label: 'Orange', },
    { label: 'Blue', },
    { label: 'Purple', },
    { label: 'White',  },
  ]

  export const colorOptions = [
    "AliceBlue", "Alizarin", "Amethyst", "AntiqueWhite", "Aqua", "Aquamarine", "Asparagus", "Azure",
    "Beige", "Bisque", "Black", "BlanchedAlmond", "Blue", "BlueViolet", "BrickRed", "Brown", "BurlyWood",
    "CadetBlue", "Camel", "CaribbeanGreen", "CarnationPink", "Cerulean", "Champagne", "Chartreuse", "Cherry",
    "Chestnut", "Chocolate", "Cinnamon", "CobaltBlue", "Coffee", "Coral", "CornflowerBlue", "Cornsilk",
    "Crimson", "Cyan",
    "DarkBlue", "DarkCyan", "DarkGoldenrod", "DarkGray", "DarkGreen", "DarkKhaki", "DarkMagenta", "DarkOliveGreen",
    "DarkOrange", "DarkOrchid", "DarkRed", "DarkSalmon", "DarkSeaGreen", "DarkSlateBlue", "DarkSlateGray", "DarkTurquoise",
    "DarkViolet", "DeepPink", "DeepSkyBlue", "Denim", "DodgerBlue",
    "Emerald", "Eggplant", "Ecru",
    "Fawn", "FernGreen", "Firebrick", "Flax", "FloralWhite", "ForestGreen", "FrenchRose", "Fuchsia",
    "Gainsboro", "Gamboge", "GhostWhite", "Gold", "Goldenrod", "Gray", "Green", "GreenYellow",
    "Honeydew", "HotPink",
    "IndianRed", "Indigo", "Ivory",
    "Jade", "Jasper", "JazzberryJam",
    "Khaki",
    "Lavender", "LavenderBlush", "LawnGreen", "Lemon", "LemonChiffon", "LightBlue", "LightCoral", "LightCyan",
    "LightGoldenrodYellow", "LightGray", "LightGreen", "LightPink", "LightSalmon", "LightSeaGreen", "LightSkyBlue",
    "LightSlateGray", "LightSteelBlue", "LightYellow", "Lime", "LimeGreen", "Linen",
    "Magenta", "Mahogany", "Maroon", "Mauve", "MidnightBlue", "MintGreen", "MistyRose", "Moccasin", "Mustard",
    "NavajoWhite", "NavyBlue",
    "Ochre", "Olive", "OliveDrab", "Orange", "OrangeRed", "Orchid",
    "PacificBlue", "PapayaWhip", "Peach", "PeachPuff", "Periwinkle", "PersianBlue", "PersianGreen", "PersianRed",
    "Pink", "Platinum", "Plum", "PowderBlue", "Pumpkin", "Purple",
    "Raspberry", "Red", "RobinEggBlue", "Rose", "RosyBrown", "RoyalBlue", "Ruby", "Rust",
    "SaddleBrown", "Salmon", "SandyBrown", "Sapphire", "Scarlet", "SeaGreen", "Seashell", "Sepia",
    "Sienna", "Silver", "SkyBlue", "SlateBlue", "SlateGray", "Snow", "SpringGreen", "SteelBlue", "Strawberry",
    "Tan", "Teal", "TerraCotta", "Thistle", "Tomato", "Turquoise",
    "Ultramarine", "Umber",
    "Vanilla", "Vermilion", "Violet",
    "Wheat", "White", "WhiteSmoke", "Wine",
    "Yellow", "YellowGreen", "Zaffre"
  ];

  export const stateOptions = [
    { value: 'Andhra Pradesh', label: 'Andhra Pradesh' },
    { value: 'Arunachal Pradesh', label: 'Arunachal Pradesh' },
    { value: 'Assam', label: 'Assam' },
    { value: 'Bihar', label: 'Bihar' },
    { value: 'Chhattisgarh', label: 'Chhattisgarh' },
    { value: 'Goa', label: 'Goa' },
    { value: 'Gujarat', label: 'Gujarat' },
    { value: 'Haryana', label: 'Haryana' },
    { value: 'Himachal Pradesh', label: 'Himachal Pradesh' },
    { value: 'Jharkhand', label: 'Jharkhand' },
    { value: 'Karnataka', label: 'Karnataka' },
    { value: 'Kerala', label: 'Kerala' },
    { value: 'Madhya Pradesh', label: 'Madhya Pradesh' },
    { value: 'Maharashtra', label: 'Maharashtra' },
    { value: 'Manipur', label: 'Manipur' },
    { value: 'Meghalaya', label: 'Meghalaya' },
    { value: 'Mizoram', label: 'Mizoram' },
    { value: 'Nagaland', label: 'Nagaland' },
    { value: 'Odisha', label: 'Odisha' },
    { value: 'Punjab', label: 'Punjab' },
    { value: 'Rajasthan', label: 'Rajasthan' },
    { value: 'Sikkim', label: 'Sikkim' },
    { value: 'Tamil Nadu', label: 'Tamil Nadu' },
    { value: 'Telangana', label: 'Telangana' },
    { value: 'Tripura', label: 'Tripura' },
    { value: 'Uttar Pradesh', label: 'Uttar Pradesh' },
    { value: 'Uttarakhand', label: 'Uttarakhand' },
    { value: 'West Bengal', label: 'West Bengal' },
    { value: 'Andaman and Nicobar Islands', label: 'Andaman and Nicobar Islands' },
    { value: 'Chandigarh', label: 'Chandigarh' },
    { value: 'Dadra and Nagar Haveli and Daman and Diu', label: 'Dadra and Nagar Haveli and Daman and Diu' },
    { value: 'Lakshadweep', label: 'Lakshadweep' },
    { value: 'Delhi', label: 'Delhi' },
    { value: 'Puducherry', label: 'Puducherry' },
  ];
  
  export const countryOptions = [
    { value: 'India', label: 'India' }
  ];
  